import gql from 'graphql-tag';

export const CREATE_CUSTOM_BOOKING_WIDGET = gql`
  mutation createCustomBookingWidget($input: CreateCustomBookingWidgetInput!) {
    createCustomBookingWidget(input: $input) {
      customBookingWidget {
        publicId
      }
    }
  }
`;
